import { releaseProxy, type Remote, wrap } from 'comlink';
import { useEffect, useRef } from 'react';

import ValidationWorker from '../../workers/validation.worker?worker&inline';
import { type ValidationWorkerApi } from './validation.shared';

const useValidationWorker = () => {
    const proxyRef = useRef<Remote<ValidationWorkerApi> | null>(null);

    useEffect(() => {
        if (typeof Worker === 'undefined') return;
        const worker = new ValidationWorker();
        proxyRef.current = wrap<ValidationWorkerApi>(worker);

        return () => {
            proxyRef.current?.[releaseProxy]();
            worker.terminate();
            proxyRef.current = null;
        };
    }, []);

    return proxyRef;
};

export { useValidationWorker };
